import React from "react";

import useTranslation from "next-translate/useTranslation";

import { makeStyles } from "tss-react/mui";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const useStyles = makeStyles()((theme) => ({
  withIconContainer: {
    fontSize: "14px",
    display: "flex",
    "& svg": {
      marginRight: "8px",
    },
  },
  withIconAndMarginContainer: {
    alignItems: "flex-start",
  },
  latestModel: {
    display: "flex",
    alignItems: "center",
    fontSize: "12px",
    "& svg": {
      fontSize: "14px",
      marginBottom: theme.spacing(0.25),
    },
  },
}));

export default function LatestModelBadge(props) {
  const { noMargin } = props;
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <span
      className={
        noMargin
          ? classes.withIconContainer
          : `${classes.withIconAndMarginContainer} ${classes.withIconContainer}`
      }
    >
      <h6 className={classes.latestModel}>
        <CheckCircleIcon fontSize="small" color="primary" />
        {t("common:isLatestModel")}
      </h6>
    </span>
  );
}
